import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';
import FilterSidebarBlock from './FilterSidebarBlock';
import ReportSidebarBlock from './ReportSidebarBlock';
import { AppRemixIcon } from '@/layout/AppComponents';
import _ from 'lodash';

export default function ResourceManagerSidebar({ activeRoute }) {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const view = useSelector((state) => state.currentPage?.view);
  const userBridge = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          <li>
            <a
              href="https://wl-resource-manager.s3.eu-central-1.amazonaws.com/manual/GUIA_definitiva+ESP_v2-GestionDeActivos.pdf"
              target="_blank"
              className="p-0"
            >
              <span className="sidebar-element">
                <AppRemixIcon icon="git-repository" className="sidebar-icon" />
                <span className="sb-title">
                  <Translator
                    file="module-resourceManager"
                    name="resource.manual"
                  />
                </span>
              </span>
            </a>
          </li>
          {(activeRoute === 'user_module_resourceManager_resource_home' ||
            activeRoute === 'user_module_resourceManager_obligation_home') && (
            <>
              <FilterSidebarBlock />
            </>
          )}
          {view === 'resource' && <ReportSidebarBlock />}
          <li className="divider" />
          <li
            className={`${
              activeRoute === 'user_module_resourceManager_resource_home'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_resourceManager_resource_home"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.resources"
                  />,
                )}
              >
                <span className="sb-title">
                  <Translator
                    file="module-resourceManager"
                    name="resource.resources"
                  />
                </span>
              </span>
            </AppLink>
          </li>
          <li
            className={`${
              activeRoute === 'user_module_resourceManager_obligation_home'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_resourceManager_obligation_home"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.obligations"
                  />,
                )}
              >
                <span className="sb-title">
                  <Translator
                    file="module-resourceManager"
                    name="resource.obligations"
                  />
                </span>
              </span>
            </AppLink>
          </li>
          <li
            className={
              activeRoute === 'user_module_resourceManager_calendar'
                ? 'active'
                : ''
            }
          >
            <AppLink
              path="user_module_resourceManager_calendar"
              params={{
                moduleBridgeHex,
              }}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.calendar"
                  />,
                )}
              >
                <span className="sb-title">
                  <Translator
                    file="module-resourceManager"
                    name="resource.calendar"
                  />
                </span>
              </span>
            </AppLink>
          </li>
          {userBridge?.permissions?.level === 0 && (
            <li
              className={
                activeRoute === 'user_module_resourceManager_settings'
                  ? 'active'
                  : ''
              }
            >
              <AppLink
                path="user_module_resourceManager_settings_resourceTemplate_list"
                params={{
                  moduleBridgeHex,
                }}
                className="p-0"
              >
                <span
                  className="sidebar-element"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-resourceManager"
                      name="resource.settings"
                    />,
                  )}
                >
                  <span className="sb-title">
                    <Translator
                      file="module-resourceManager"
                      name="resource.settings"
                    />
                  </span>
                </span>
              </AppLink>
            </li>
          )}
        </ul>
      </Accordion>
    </Sidebar>
  );
}
